/* Алерт перерасхода лимита клиентов (TRN-2) — nav.js limitAlertHTML.
   Без clientId — общий (дашборд); с clientId — только у клиента сверх лимита (карточка, конструктор). */
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useClients, useMe } from '../lib/data';
import { plural } from '../lib/format';

export function LimitAlert({ clientId }: { clientId?: string }) {
  const me = useMe().data;
  const cs = useClients().data;
  if (!me || !cs) return null;
  const over = cs.filter((c) => c.overLimit);
  /* Подписка закончилась — править всё равно нельзя, об этом говорит полоса под шапкой */
  if (me.sub.ended || !over.length || (clientId && !over.some((c) => c.id === clientId))) return null;
  const n = cs.length,
    limit = me.clientLimit;
  return (
    <div className="lalert" role="alert">
      <span className="t">
        <b>Перерасход лимита клиентов</b>
        <s>
          {clientId ? (
            `Клиент сверх лимита тарифа — до ${limit} клиентов. Он пользуется приложением как обычно, но, пока вы не измените лимит, составлять ему тренировки нельзя.`
          ) : (
            <>
              В аккаунте {n} {plural(n, 'клиент', 'клиента', 'клиентов')} при лимите тарифа {limit}. Клиенты сверх лимита пользуются приложением, но, пока вы не измените лимит, составлять им тренировки нельзя:{' '}
              {over.map((c, i) => (
                <Fragment key={c.id}>
                  {i > 0 && ', '}
                  <Link to={'/clients/' + c.id}>{c.name}</Link>
                </Fragment>
              ))}
              .
            </>
          )}
        </s>
      </span>
      <Link className="btn sm" to="/profile#billing">
        Изменить тариф
      </Link>
    </div>
  );
}
